/**
 * ProtectedRoute.jsx
 * Path: frontend/src/components/ProtectedRoute.jsx
 * Description: Chroni trasy wymagające sesji lub roli admin.
 * Related: App.jsx
 */

import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, token } = useContext(AuthContext);

  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && String(user.role || "").toLowerCase() !== "admin") {
    return <Navigate to="/calendar" replace />;
  }

  return children;
}

